import CategoryMenuItem from './CategoryMenuItem'

export default CategoryMenuItem
